// extracted by mini-css-extract-plugin
module.exports = {"appModal":"AppModal_appModal__RIw_r"};